import { useState } from 'react';
import axios from 'axios';
import Loading from '../../../component/common/loading/Loading.jsx';
import MergedTableHeader from '../../../component/common/dataGrid/MergedTableHeader.jsx';
import Pagination from '../../../component/common/dataGrid/Pagination.jsx';
import TrmsSubTable from './TrmsSubTable.jsx';
import { useIs17Inch } from '../../../hooks/useBreakPoint.js';

import '../../../css/data-grid.css';
import { useDynamicStyle } from '../../../hooks/useDynamicStyle.js';
import * as Icons from '../../../images/icons/icons_component.js';

const TrmsDataGrid = ({ propsInfo, state, pageInfo, setPageInfo, mergeConfig, ver }) => {

    const [subState, setSubState] = useState({
        dataList: [],
        isSearched: false,
        isLoading: false,
        subHead: [['NO', '구분', '상세', '시행/입실/부착', '시행/입실/부착', '판독결과보고/퇴실/제거', '판독결과보고/퇴실/제거', '시행의사면허번호'], ['NO', '구분', '상세', '일자', '시간', '일자', '시간', '시행의사면허번호']],
        subColumn: ['TRHTSEQU', 'CODEDESC', 'TRHTVALU', 'TRHTEXDT', 'TRHTEXTM', 'TRHTEDDT', 'TRHTEDTM', 'TRHTDONO']
    })

    const [selectTrms, setSelectTrms] = useState();

    const dataList = state.dataList;
    const isSearched = state.isSearched;
    const isLoading = state.isLoading;

    const dataHead = propsInfo.dataHead;
    const dataColumn = propsInfo.dataColumn;
    const excelHead = propsInfo.excelHead;

    const paginationTF = pageInfo.paginationTF;

    const onHandlePage = (page) => {
        if (page !== pageInfo.currentPage) {
            setPageInfo(prev => ({
                ...prev,
                currentPage: page
            }));
        }
    };

    const paginationInfo = {
        ...pageInfo,
        onPageChange: onHandlePage,
    }

    const computeRowSpans = (dataList, mergeConfig = [], allColumns = []) => {
        const rowSpans = dataList.map(() => ({}));

        mergeConfig.forEach(({ key: colKey, row, nullable }) => {
            let prevValue = null;
            let startIndex = 0;
            let mergeCount = 1;

            for (let i = 0; i < dataList.length; i++) {
                const currentValue = dataList[i][colKey];
                const isMergeable = nullable ? currentValue === prevValue : (currentValue === prevValue && currentValue !== '' && currentValue !== null);
                if (isMergeable) {
                    if (row == null || mergeCount < row) {
                        rowSpans[startIndex][colKey] += 1;
                        rowSpans[i][colKey] = 0;
                        mergeCount += 1;
                    } else {
                        rowSpans[i][colKey] = 1;
                        startIndex = i;
                        mergeCount = 1;
                    }
                } else {
                    rowSpans[i][colKey] = 1;
                    startIndex = i;
                    mergeCount = 1;
                    prevValue = currentValue;
                }
            }
        });

        dataList.forEach((_, i) => {
            allColumns.forEach(colKey => {
                if (!(colKey in rowSpans[i])) {
                    rowSpans[i][colKey] = 1;
                }
            });
        });

        return rowSpans;
    };

    const rowSpans = computeRowSpans(dataList, mergeConfig ?? [], dataColumn);
    const colSpan = excelHead.length < 1 ? dataHead.length : excelHead.length;

    const onClickPopup = (key, e) => {
        const targetRow = e.target.closest('tr');
        if (!targetRow) {
            console.log("❌ 클릭된 요소가 <tr>이 아닙니다.");
            return;
        }

        const emogcode = targetRow.dataset.trmsemcd;
        const searchIdno = targetRow.dataset.trmsidno;
        const searchIndt = targetRow.dataset.trmsindt;
        const searchIntm = targetRow.dataset.trmsintm;

        const sendData = {
            emogcode,
            searchIdno,
            searchIndt,
            searchIntm,
            flag: 'trms'
        };

        if (isSearched && emogcode && searchIdno) {
            localStorage.setItem('trmsData', JSON.stringify(sendData));
            const popup = window.open(
                `/nedis/trmsInfo/trms_naeyeok_${ver}_popup.do`,
                "팝업",
                "scrollbars=1, resizable=0, width=1900, height=910, top=50"
            );
            if (!popup) {
                alert("팝업이 차단되었습니다. 브라우저 설정에서 허용해 주세요.");
            }
            setSelectTrms(key);
            if (ver === 'V2') {
                setSubState(prev => ({
                    ...prev,
                    isLoading: true
                }));
                subSearch(sendData);
            }
        } else {
            console.log("⚠️ 필수 데이터가 누락되어 팝업을 열지 않습니다.");
        }
    };

    const subSearch = async (sendData) => {
        try {
            const response = await axios.get('/trmsapi/oesangweb/bdtrms_list_sub.do',
                { params: sendData }
            );
            setSubState(prev => ({
                ...prev,
                dataList: response.data,
                isSearched: true
            }));
            setSubState(prev => ({
                ...prev,
                isLoading: false
            }));
        } catch (error) {
            console.error('데이터 로딩 중 오류 발생:', error);
        }

    }

    // Dynamic Style Hook
    const { lightBackColor, borderColorGray, hoverLightFontColor, selectGridCell } = useDynamicStyle();

    const is17Inch = useIs17Inch();

    return (
        <>
            {isLoading ? <Loading /> :
                <div className='data_grid_container flex_row_media_set gap-4'>
                    <div className='data_grid_container hp-60 v2_list_media_set'>
                        <hr className={`border-t-2 mr-1-1 ${borderColorGray}`} />
                        <div className={`data_list_table ${isSearched ? 'grid-animation' : ''}`}>
                            <table>
                                <MergedTableHeader
                                    headers={dataHead}
                                />
                                <tbody>
                                    {dataList.length === 0 ? (
                                        <tr>
                                            <td colSpan={1000} className='empty_box'>
                                                <span className={`data_empty ${lightBackColor}`}>
                                                    {isSearched ? <Icons.EmptySalgu /> : <Icons.NullSalgu />}
                                                    {isSearched ? '해당하는 데이터가 없습니다.' : '검색 버튼을 눌러 데이터를 조회하세요.'}
                                                </span>
                                            </td>
                                        </tr>
                                    ) : (
                                        dataList.map((item, rowIndex) => {
                                            const regex = /[^0-9]/g;
                                            const key = item.PTMIMASK.replace(regex, "") + rowIndex;
                                            const select = selectTrms === key;
                                            const gridColor = rowIndex % 2 === 0 ? lightBackColor : '';
                                            return (
                                                <tr onClick={(e) => onClickPopup(key, e)}
                                                    key={key}
                                                    className={`cursor-pointer ${gridColor} ${hoverLightFontColor} ${select && select ? selectGridCell : ''}`}
                                                    data-trmsemcd={item.TRMSEMCD}
                                                    data-trmsidno={item.TRMSIDNO}
                                                    data-trmsindt={item.TRMSINDT}
                                                    data-trmsintm={item.TRMSINTM}>
                                                    {dataColumn.map((col, colIndex) => {
                                                        const span = rowSpans[rowIndex][col];
                                                        if (span) {
                                                            return (
                                                                <td key={colIndex} rowSpan={span}>
                                                                    {item[col]}
                                                                </td>
                                                            );
                                                        } else {
                                                            return null;
                                                        }
                                                    })}
                                                </tr>
                                            )
                                        })
                                    )}
                                </tbody>
                            </table>
                        </div>
                        <hr className='mr-1-1 co_border_gray' />
                        {dataList.length === 0 || !paginationTF ? (
                            <br />
                        ) : (
                            <Pagination
                                paginationInfo={paginationInfo}
                                pageSet={7}
                            />
                        )}
                    </div>
                    {ver === 'V2' && 
                        <>
                            <hr className={is17Inch ? 'h-full border-l' : ''} />
                            <TrmsSubTable subState={subState} />
                        </>
                    }
                </div>
            }
        </>
    );
};

export default TrmsDataGrid;